<!-- 评分地址栏组件 -->
<template>
  <!-- <div class="component-score-address" :class="{'no-cover':!couponDetail.scenicCover}" @click.stop> -->
  <div class="component-score-address" @click.stop>
    <div
      class="store-header"
      :class="{ 'no-arrow': !couponDetail.isMultipleStore }"
      @click="couponDetail.isMultipleStore && goStorePage('')"
    >
      <!-- <span class="main-title">适用门店</span> -->
      <!-- <span v-if="couponDetail.isMultipleStore" class="weak-title"
        >{{ couponDetail.storeCount }}家门店通用</span
      > -->
    </div>
    <div
      class="hotel-score"
      :class="{
        'no-arrow': !couponDetail.isStore && !couponDetail.hotelScenicId,
        'no-address': couponDetail.isShowGoodsAddress,
        'no-opening-hours': !couponDetail.isStore,
      }"
      style="-webkit-user-select: text"
      @click="
        couponDetail.isStore
          ? goStorePage('goDetailPage')
          : goGoodsDetailsPage()
      "
    >
      <img
        :src="facePic"
        :data-original="
          couponDetail.scenicCover + '?imageView2/1/w/90/h/68/interlace/1/q/85/'
        "
        v-if="couponDetail.scenicCover"
      />
      <div class="hotel-detail" :class="{ 'jump-strore': !fxbInviteCode }">
        <div class="business-top">
          <span
            class="business-name"
            :class="isIos ? 'ios-name' : 'android-name'"
            >{{ couponDetail.hotelName }}

            <span
              v-if="couponDetail.storeData && couponDetail.storeData.branchName"
              >({{ couponDetail.storeData.branchName }})</span
            >
          </span>
          <span
            :class="[
              'houtel-type',
              `houtel-type${filterHotelColor(magscenicDetail.star)}`,
            ]"
            v-if="
              magscenicDetail &&
              (magscenicDetail.productType == 1 ||
                magscenicDetail.productType == 4)
            "
            >{{ magscenicDetail.star | filterHoutelType }}</span
          >
          <!-- <span class="distance-label" v-if="couponDetail.isMultipleStore">
            离您最近
          </span> -->
        </div>
        <div class="business-info" v-if="magscenicDetail">
          <template
            v-if="
              (magscenicDetail.productType == 1 ||
                magscenicDetail.productType == 4) &&
              magscenicDetail.hotelFacilities &&
              magscenicDetail.hotelFacilities.length
            "
          >
            <span class="business-time" v-if="storeTime">{{ storeTime }}</span>

            <span
              v-for="(item, index) in magscenicDetail.hotelFacilities.slice(
                0,
                3
              )"
              :key="index"
              class="hotel-fac-item"
            >
              {{ item.name + (item.feeType == 2 ? "收费" : "") }}
            </span>
          </template>

          <template
            v-if="
              magscenicDetail.productType == 2 && magscenicDetail.scenicOpenTime
            "
          >
            <span class="hotel-fac-item"
              >开放时间：{{ magscenicDetail.scenicOpenTime }}</span
            >
          </template>
        </div>
        <!-- 评分大于3.5 || 有评价才展示评分模块 -->
        <template v-if="couponDetail.averageRate * 1 >= 3.5">
          <div
            @click.stop="toComments"
            class="detail-item-score"
            v-if="couponDetail.averageRate * 1 >= 3.5"
          >
            <ycf-star :point="couponDetail.averageRate * 1"></ycf-star>
          </div>
        </template>
      </div>
    </div>
    <div class="row-line" :style="{ height: isIos ? '.5px' : '1px' }"></div>
    <div
      class="hotel-address"
      v-if="!couponDetail.isShowGoodsAddress"
      :class="{
        'no-arrow': isOtherBrowser,
        'no-address': !storeAddress,
        'long-address': storeAddress.length > (telephone ? 20 : 16),
      }"
    >
      <!-- <div class="adress-label">{{couponDetail.address|filterRepeatStr}}</div> -->
      <div
        class="adress-label"
        :class="{ 'no-telphone-label': telephone === '' }"
      >
        {{ storeAddress }}
      </div>
      <div
        class="col-line"
        :style="{ width: isIos ? '.5px' : '1px' }"
        :class="{ 'no-telphone': !telephone }"
      ></div>
      <div class="adress-operation" :class="{ 'no-telphone': !telephone }">
        <!-- ///TLH220921 -->
        <div class="btn navigation-btn" @click="gotoNav('500100')">
          <ycf-image
            class="icon"
            src="../../assets/img/address_icon@2x.png"
          ></ycf-image>
          <span>导航</span>
        </div>

        <div
          class="btn phone-btn"
          v-if="telephone"
          @click.stop="handleClickPhone(telephone)"
        >
          <ycf-image
            class="icon"
            src="../../assets/img/telephone_icon@2x.png"
          ></ycf-image>
          <span>电话</span>
        </div>
      </div>
    </div>
    <!--限购退款规则弹框-->
    <div
      class="Layer-FullScreen address-pop"
      v-if="loadAddressSelect"
      v-show="showAddressPop"
      @click="slideDownAddress"
    >
      <div
        class="main-bottom"
        :class="{ 'slide-down': addressSlideDown }"
        @click.stop
      >
        <p
          class="address-item"
          @click="navToMap(item.id)"
          v-for="item in actions"
          :key="item.id"
        >
          {{ item.name }}
        </p>

        <p class="address-item" @click="slideDownAddress">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
window.Vue &&
  window.Vue.filter("filterRepeatStr", function (value) {
    //过滤指定规则的重复字符串
    var val = value;
    if (typeof val == "string" && val.length >= 6) {
      filterRule();
    }
    return val;

    //过滤规则：过滤不低于三个字符并相邻的重复字符串
    function filterRule() {
      var result = -1, //索引结果
        hasRepeat = false; //有重复的字符串
      for (var i = 0, num = 3; i + num * 2 <= val.length; i++) {
        result = val.indexOf(val.substr(i, num), i + num);
        if (result != -1) {
          if (i + num == result) {
            //相邻
            val = val.replace(val.substr(result, num), "");
            filterRule(); //递归过滤
            break;
          }
          hasRepeat = true;
          i--;
          num++;
          continue;
        }
        if (hasRepeat) {
          hasRepeat = false;
          num = 3;
        }
      }
    }
  });

/*云客赞app下载栏组件
 * <component-score-address :coupon-detail="couponDetail"></component-score-address>
 */
import { buryingPoint } from "@/util/buryingPoint";
import { toQueryString, toast } from "@ykz/ykz-util/base";
import databus, { Origins } from "@ykz/ykz-http/core";
import {
  isIos,
  isAndroid,
  isYkzMiniprogram,
  isYkzAlipayMiniprogram,
  isOtherBrowsers,
} from "@ykz/ykz-util/platform";

import { openLocation } from "@ykz/ykz-util/location/open";
import { getWeChatList } from "@ykz/ykz-http/common";
export default {
  name: "score_address",
  data: function () {
    return {
      fxbInviteCode: getUrlParams("fxbInviteCode") || "",
      weChatId: getUrlParams("weChatId") || window.weChatId,
      goodId: getUrlParams("goodId") || "", //商品id
      isAPP: window.mobileEnv == "app" ? true : false, //是否在云客赞app打开页面
      isMini: isYkzMiniprogram(), //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(), // 是否在支付宝小程序内
      simData: getUrlParams("simData") || "", //模拟假数据的参数
      availableWechatId: false, //当前公众号是否允许展示评价咨询
      isOtherBrowser: isOtherBrowsers(), //除微信、app外的第三方浏览器打开页面
      isShop: sessionStorage.getItem("session_isShop") || "", //店铺模式
      isIos: isIos(), //设备系统
      isAndroid: isAndroid(),
      // testAddress: '测试短地址',
      testAddress: "测试短地址测试短地址测试短地址测试短地址短地址",
      loadAddressSelect: false,
      showAddressPop: false,
      addressSlideDown: true,
      actions: [
        { id: 1, name: "百度地图" },
        { id: 2, name: "腾讯地图" },
        { id: 3, name: "高德地图" },
      ],
    };
  },
  props: {
    couponDetail: {
      default: () => ({}),
    },
    magscenicDetail: {
      default: () => ({}),
    },

    kv: {
      default: () => ({}),
    },
  },
  watch: {
    showAddressPop: function (val) {
      this.setOverflow(val);
    },
  },
  filters: {
    filterHoutelType(value) {
      if (value == "五星") {
        return "豪华型";
      } else if (value == "四星") {
        return "高档型";
      } else {
        return "舒适型";
      }
    },
  },

  computed: {
    storeTime() {
      let year = "";
      if (this.magscenicDetail) {
        const { openTime, decorationTime } = this.magscenicDetail;

        if (decorationTime) {
          year = decorationTime.slice(0, 4) + "年装修";
        } else if (openTime) {
          year = openTime.slice(0, 4) + "年开业";
        }
      }
      return year;
    },
    storeAddress() {
      return this.couponDetail.storeData
        ? this.couponDetail.storeData.address || ""
        : this.couponDetail.address || "";
    },
    telephone() {
      return this.couponDetail.storeData
        ? this.couponDetail.storeData.telephone
        : this.couponDetail.phone;
    },
    facePic() {
      return this.couponDetail.storeData
        ? this.couponDetail.storeData.facePic
        : this.couponDetail.scenicCover;
    },
  },

  mounted: function () {
    typeof window.componentCenter == "object" || (window.componentCenter = {});
    window.componentCenter.scoreAddress = this;
    console.log("ycf组件初始化：scoreAddress", this.couponDetail);
    //this.ajaxGetWeChatList();
    if (this.isAPP) {
      ykzApp.ready(function () {
        !ykzApp.showAddressMap &&
          $(".component-score-address .hotel-address").addClass("no-arrow"); //低于v1.5.0版本的app,隐藏酒店地址箭头
      });
    }
  },
  methods: {
    filterHotelColor(value) {
      if (value == "五星") {
        return 1;
      } else if (value == "四星") {
        return 2;
      } else {
        return 3;
      }
    },
    //兼容ios系统的overflow对z-index层级关系的影响
    setOverflow: function (val) {
      if (val) {
        $(".scroll-area").css("overflow-y", "hidden");
      } else {
        $(".scroll-area").css("overflow-y", "auto");
      }
    },

    handleClickPhone(phoneNumber) {
      buryingPoint("SXY-DJDPDH", "点击店铺电话", this.kv);
      window.location.href = `tel:${phoneNumber}`;
    },
    // 跳转酒景评论列表
    toComments() {
      const { hotelScenicId, storeData } = this.couponDetail;
      const scenicId = hotelScenicId ? hotelScenicId : storeData.storeId || "";
      const url =
        "/front/index/userEvaluation?" +
        toQueryString({
          scenicId: scenicId,
          weChatId: this.weChatId,
        });

      location.href = url;
    },
    //跳转到门店页
    goStorePage: function (goDetailPage) {
      var that = this;
      if (!goDetailPage && that.couponDetail.isMultipleStore) {
        buryingPoint("SXY-DJMDLB", "点击门店列表", that.kv);
        window.location.href =
          "/front/platform/storeList?" +
          toQueryString({
            weChatId: that.weChatId,
            type: 1,
            productId: that.goodId,
          });
      } else {
        buryingPoint("SXY-DJDPXQ", "点击店铺详情", that.kv);
        window.location.href =
          "/front/platform/storeDetails?" +
          toQueryString({
            weChatId: that.weChatId,
            storeId: that.couponDetail.storeData.storeId,
            isShop: that.isShop,
            promotion: sessionStorage.getItem("isShop_promotion") || null,
          });
      }

      YCF_Plugin.anchorPoint("门店展示", "shopdetail_show", "");
    },

    //跳转到酒景详情页
    goGoodsDetailsPage: function () {
      var that = this;
      buryingPoint("SXY-DJDPXQ", "点击店铺详情", this.kv);

      if (that.fxbInviteCode) return false;
      if (!this.couponDetail.hotelScenicId) return false;
      YCF_Plugin.reportUserAnchors({
        event_id: "520008",
        properties: {
          scenic_id: this.couponDetail.hotelScenicId,
        },
      }).always(function () {
        window.location.href =
          "/front/platform/goodsDetails?" +
          toQueryString({
            weChatId: that.weChatId,
            scenicId: that.couponDetail.hotelScenicId,
            scenicFrom: "prductDetail",
            simData: that.simData,
            showAllWechat:
              document.referrer &&
              document.referrer.search(
                /\/front\/platform\/goodsDetails.*[?&]weChatId=1/
              ) != -1
                ? 1
                : null,
            isShop: that.isShop,
            promotion: sessionStorage.getItem("isShop_promotion") || null,
          });
      });
    },

    //打开地图导航
    gotoNav: function () {
      console.log("点击导航");
      var that = this;

      window.closeLocation = "0";
      window.initWeiXinSign();
      buryingPoint("SXY-DJDPDH", "点击店铺导航", that.kv);
      // if (this.isOtherBrowser) return;
      YCF_Plugin.reportUserAnchors({
        event_id: "500100",
        event_content: {
          item_id: this.goodId,
        },
      }).always(function () {
        ///TLH220921

        if (that.isAPP) {
          ykzApp.ready(function () {
            ykzApp.showAddressMap &&
              ykzApp.showAddressMap({
                latitude: that.couponDetail.latitude,
                longitude: that.couponDetail.longitude,
                title:
                  that.couponDetail.cateId == 10
                    ? that.couponDetail.showPlace
                    : that.couponDetail.hotelName,
                address: that.couponDetail.address,
              });
          });
        } else if (that.isOtherBrowser) {
          that.slideUpAddress();
        } else {
          openLocation({
            latitude: that.couponDetail.latitude,
            longitude: that.couponDetail.longitude,
            name:
              that.couponDetail.cateId == 10
                ? that.couponDetail.showPlace
                : that.couponDetail.hotelName, // 位置名
            address: that.couponDetail.address, // 地址详情说明
          });
        }
      });
    },

    navToMap(id) {
      const { latitude, longitude, hotelName } = this.couponDetail;
      let href = "";
      // 参考文档： https://blog.csdn.net/Smile_ping/article/details/113185690
      if (id == 1) {
        href = `https://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${hotelName}&content=${this.storeAddress}&output=html`;
      }
      if (id == 2) {
        href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};title:${hotelName};addr:${this.storeAddress}&referer=myapp`;
      }
      if (id == 3) {
        href = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${hotelName}&coordinate=gaode&callnative=1`;
      }
      window.open(href, "_blank");
      // let url = "";
      // if (this.isAndroid) {
      //   switch (id) {
      //     case 1:
      //       url = `baidumap://map/marker?location=${latitude},${longitude}&title=${this.storeAddress}&coord_type=gcj02&src=andr.baidu.openAPIdemo`;
      //       break;
      //     case 2:
      //       url = `qqmap://map/marker?marker=coord:${latitude},${longitude};title:${hotelName};addr:${this.storeAddress}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`;
      //       break;
      //     case 3:
      //       url = `androidamap://viewMap?sourceApplication=appname&poiname=${this.storeAddress}&lat=${latitude}&lon=${longitude}&dev=0`;
      //       break;
      //     default:
      //       break;
      //   }
      // } else if (this.isIos) {
      //   switch (id) {
      //     case 1:
      //       url = `baidumap://map/marker?location=${latitude},${longitude}&title=${this.storeAddress}&content=${this.storeAddress}&src=ios.baidu.openAPIdemo&coord_type=gcj02`;
      //       break;
      //     case 2:
      //       url = `qqmap://map/marker?marker=coord:${latitude},${longitude};title:${hotelName};addr:${this.storeAddress}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`;
      //       break;
      //     case 3:
      //       url = `iosamap://viewMap?sourceApplication=applicationName&poiname=${this.storeAddress}&lat=${latitude}&lon=${longitude}&dev=0`;
      //       break;
      //     default:
      //       break;
      //   }
      // }
      // if (url != "") {
      //   window.open(url, "_blank");
      // }

      this.slideDownAddress();
    },

    //向上滑动显示弹框
    slideUpAddress: function () {
      this.loadAddressSelect = true;
      this.$nextTick(function () {
        var that = this;
        that.showAddressPop = true;
        setTimeout(function () {
          that.addressSlideDown = false;
          location.hash != "#addressPop" && (location.hash = "addressPop");
        }, 30);
      });
    },

    //向下滑动隐藏弹框
    slideDownAddress: function () {
      var that = this;
      that.addressSlideDown = true;
      setTimeout(function () {
        that.showAddressPop = false;
        location.hash == "#addressPop" && history.go(-1);
      }, 300);
    },

    // 获取当前公众号是否可以展示评价模块
    ajaxGetWeChatList: function () {
      var that = this;
      getWeChatList().then(function (res) {
        if (res.code == 1000 && res.bcode == 100) {
          res.content = res.content || [];
          for (var i in res.content) {
            if (res.content[i] == that.weChatId) {
              that.availableWechatId = true;
              break;
            }
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
//评分地址栏组件
.component-score-address {
  margin: pxToRem(20) 0;
  background-color: #fff;
  padding: 0 pxToRem(24);
  // padding-top: 1px;
  font-size: 0;

  .no-arrow::after {
    display: none;
  }

  .store-header {
    display: none;
    position: relative;
    font-size: pxToRem(32);
    padding-top: pxToRem(32);
    // padding-bottom: pxToRem(32);
    color: #333333;
    line-height: pxToRem(48);

    .main-title {
      font-weight: 800;
    }

    .weak-title {
      position: absolute;
      top: pxToRem(26);
      right: pxToRem(36);
      color: #585858;
      // font-weight: 400;
      font-size: pxToRem(24);
      &::after {
        position: absolute;
        top: 50%;
        right: pxToRem(-38);
        transform: translateY(-50%);
        content: "\e613";
        font-size: pxToRem(22);
        color: #cacaca;
        font-family: "iconfont" !important;
      }
    }
  }
  .hotel-score {
    position: relative;
    padding: pxToRem(34) 0 pxToRem(20) 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    // height: pxToRem(80);
    // border-bottom: pxToRem(1) solid #E4E6E7;

    &.no-address {
      padding-bottom: pxToRem(31-6);
    }
    &.no-opening-hours {
      position: relative;
      width: 100%;
      // height: pxToRem(70);
      // margin: pxToRem(-6) 0 pxToRem(20) 0;
      .business-name {
        // position: absolute;
        top: pxToRem(4);
        line-height: pxToRem(48);

        &.android-name {
          font-weight: 700;
        }
        &.ios-name {
          font-weight: 500;
        }
      }
      .houtel-type {
        font-size: 22px;
        margin: 0 10px;
        padding: 0 16px;
        height: 42px;
        display: flex;
        align-items: center;
        box-shadow: 1px 1px 17px 0 rgba(165, 165, 165, 0.3);
        border-radius: 20px;
        border: 1px solid #fff;
        &.houtel-type1 {
          background-color: #262626;
          color: #d6bdb0;
        }
        &.houtel-type2 {
          background-color: #3c3d89;
          color: #fae9d6;
        }
        &.houtel-type3 {
          background-color: #ec9e41;
          color: #feffff;
        }
      }
    }
    > img {
      vertical-align: middle;
      width: pxToRem(92);

      // margin-left: pxToRem(10);
      border-radius: pxToRem(5);
    }

    > .hotel-detail {
      margin-left: pxToRem(16);
      display: flex;
      flex-direction: column;

      // height: pxToRem(82);

      .business-top {
        line-height: pxToRem(48);
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;

        .business-name {
          // padding-top: pxToRem(4);
          display: block;
          // line-height: pxToRem(48);
          color: #333333;
          font-size: pxToRem(30);
          max-width: pxToRem(400);
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          &.android-name {
            font-weight: 700;
          }
          &.ios-name {
            font-weight: 500;
          }
        }

        .distance-label {
          width: pxToRem(90);
          height: pxToRem(24);
          line-height: pxToRem(28);
          margin-left: pxToRem(18);
          font-size: pxToRem(20);
          text-align: center;
          color: #585858;
          // font-weight: 400;
          background: #f5f5f5;
          border-radius: pxToRem(4);
        }
      }

      .detail-item-score {
      }

      .business-info {
        // height: pxToRem(30);
        font-size: pxToRem(24);
        font-weight: 400;
        line-height: 1.4;
        max-width: pxToRem(500);
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          padding-right: 26px;
          position: relative;
          color: #333;
          &::after {
            content: "";
            position: absolute;
            right: 13px;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 90%;
            background: #666;
          }
          &:last-child {
            padding-right: 0;
            &::after {
              display: none;
            }
          }
        }
        .business-time {
          color: #333;
        }
        .opening-hours {
          margin-right: pxToRem(8);
        }
        .time-mode {
          text-align: left;
        }
      }
    }
  }
  .jump-strore {
    &::after {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      content: "\e613";
      font-size: pxToRem(22);
      color: rgb(202, 202, 202);
      font-family: "iconfont" !important;
    }
  }
  .row-line {
    width: 100%;
    background: #e4e6e7;
  }

  //限购退款规则弹框
  .address-pop {
    .main-bottom {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      border-radius: pxToRem(10) pxToRem(10) 0 0;
      transition: transform 0.3s;
      background-color: unset !important;
      &.slide-down {
        transform: translateY(100%);
      }

      .address-item {
        background-color: #fff;
        padding: pxToRem(26);
        font-size: pxToRem(32);
        border-bottom: pxToRem(1) solid #f6f6f6;
        line-height: pxToRem(48);
        text-align: center;
        color: #303030;
        &:first-child {
          border-top-left-radius: pxToRem(16);
          border-top-right-radius: pxToRem(16);
        }
        &:last-child {
          border-bottom: none;
          padding-bottom: pxToRem(48);
        }
      }
    }
  }

  .hotel-address {
    position: relative;
    height: pxToRem(100);
    font-size: pxToRem(26);
    color: #333333;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    &.long-address {
      height: pxToRem(132);
    }
    .adress-label {
      max-width: pxToRem(428);
      font-size: pxToRem(26);
      line-height: pxToRem(40);
      // padding-right: pxToRem(25);
      color: #333333;
      font-weight: 400;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      &.no-telphone-label {
        max-width: pxToRem(536);
      }
    }
    .col-line {
      position: absolute;
      top: auto;
      right: pxToRem(258);
      height: pxToRem(48);
      background: #e4e6e7;
      &.no-telphone {
        position: absolute;
        top: auto;
        right: pxToRem(132);
        height: pxToRem(48);
        background: #e4e6e7;
      }
    }
    .adress-operation {
      width: pxToRem(258);
      height: pxToRem(48);
      // border-left: pxToRem(1) solid #e4e6e7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      &.no-telphone {
        width: pxToRem(132);
      }
      .btn {
        position: relative;
        // width: pxToRem(100);
        color: #ff7124;
        height: pxToRem(40);
        border-radius: pxToRem(100);
        background: #ffffff;
        border: 1px solid #ff7124;
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        align-items: center;

        .icon {
          width: pxToRem(28);
          height: pxToRem(28);
          margin-left: pxToRem(9);
        }
        span {
          padding-right: 10px;
          font-size: pxToRem(22);
          line-height: pxToRem(40);
          font-weight: 400;
        }
      }

      .navigation-btn {
        margin-left: pxToRem(32);
      }

      .phone-btn {
        // margin-left: pxToRem(40);
      }
    }

    &.no-address::before {
      display: none;
    }
  }
}
</style>
